<template>
    <div class="edit">
        <!-- 删除确认框 -->
        <RemoveConfirmDialog :visible="removeDialog.visible"
            :title="liveRoomSettings.roomTitle"
            @remove="onRemoveConfirm()"
            @cancel="removeDialog.visible = false" />
        <!-- 直播间表单 -->
        <Form ref="liveRoomForm" :label-width="120" :model="liveRoomSettings" :rules="liveRoomRules">
            <FormItem :label="$t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.roomTitle')" prop="roomTitle">
                <Input class="room-item" v-model.trim="liveRoomSettings.roomTitle" show-word-limit :maxlength="50"/>
            </FormItem>
            <FormItem :label="$t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.roomType.title')" prop="roomType">
                <Select class="room-item" v-model="liveRoomSettings.roomType">
                    <Option :value="2">{{ tt('liveRoomManagement.roomType.publishLiveRoom') }}</Option>
                    <Option :value="1">{{ tt('liveRoomManagement.roomType.dedicatedLiveRoom') }}</Option>
                    <Option v-if="hasPermission('linkLive')" :value="4">{{ $t('liveRoomManagement.roomType.linkLiveRoom') }}</Option>
                    <!-- <Option v-if="hasPermission('slowLive')" :value="5">{{ $t('liveRoomManagement.roomType.slowLiveRoom') }}</Option> -->
                </Select>
                <span style="margin-left: 10px;color: red">{{ tt('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.roomType.prompt') }}</span>
            </FormItem>
            <FormItem :label="$t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.timeDescription.title')" prop="timeDescription">
                <DatePicker
                    @on-change="liveRoomSettings.timeDescription=$event"
                    :value="liveRoomSettings.timeDescription"
                    class="room-item"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm"
                    :placeholder="$t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.timeDescription.placeholder')"
                ></DatePicker>
            </FormItem>
            <FormItem :label="$t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.roomDescription')" prop="roomDescription">
                <Input v-model.trim="liveRoomSettings.roomDescription" class="input-textarea" show-word-limit type="textarea" :rows="4" :maxlength="200" style="width: 400px"/>
            </FormItem>
            <FormItem v-if="liveRoomSettings.roomId==0 && orignPublicPageTemplateData.length > 0" :label="$t('liveRoomManagement.liveRoomDetail.livePageManagement.livePageSettings.publicPageTemplate')">
                <div class="room-item">
                <Select   style="width: 30%" :value="templateOption" @on-select="selectScreenOption"  >
                    <Option v-for="item in publicPageTemplatefilterOption" :value="item.value"  :key="item.label" :label="item.label"></Option>
                </Select>
                <Select  :key="templateOption" :value="liveRoomSettings.templateId" style="width: 70%"  @on-select="selectPublicPage"><!--@on-open-change="queryPublicPageTemplate" -->
                    <template v-for="item in orignPublicPageTemplateData">
                        <Option v-if="item.type==templateOption" :value="item.id"  :key="item.name" :label="item.name">
                        </Option>
                    </template>
                </Select>
                </div>
            </FormItem>
            <FormItem :label="$t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.paidLive.title')" prop="paidLive" v-if="globalConfig.paidLiveFlag">
                <Select v-model="liveRoomSettings.paidLive" class="room-item">
                    <Option :value="0">{{ $t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.paidLive.no') }}</Option>
                    <Option :value="1">{{ $t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.paidLive.yes') }}</Option>
                </Select>
            </FormItem>
            <FormItem v-if="hasPermission('liveRoomMultiLive')" :label="$t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.multiLive.title')" prop="multiLive">
                <Select v-model="liveRoomSettings.multiLive" class="room-item">
                    <Option :value="0">{{ $t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.multiLive.no') }}</Option>
                    <Option :value="1">{{ $t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.multiLive.yes') }}</Option>
                </Select>
            </FormItem>
            <FormItem
                :label="$t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.discussAuditMechanism.title')"
                prop="discussAuditMechanism"
                v-if="globalConfig.showAfterReview"
            >
                <Select v-model="liveRoomSettings.discussAuditMechanism" class="room-item">
                    <Option :value="0">{{ $t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.discussAuditMechanism.type0') }}</Option>
                    <Option :value="1">{{ $t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.discussAuditMechanism.type1') }}</Option>
                </Select>
            </FormItem>
            <FormItem
                :label="$t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.discussAuditStartDatetime.title')"
                prop="discussAuditStartDatetime"
                v-if="globalConfig.showAfterReview && liveRoomSettings.discussAuditMechanism == 1"
            >
                <DatePicker
                    ref="discussAuditStartDatetime"
                    @on-change="liveRoomSettings.discussAuditStartDatetime=$event"
                    :value="liveRoomSettings.discussAuditStartDatetime"
                    :options="discussAuditStartDatetimeOptions"
                    class="room-item"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    :placeholder="$t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.discussAuditStartDatetime.placeholder')"
                ></DatePicker>
            </FormItem>
            <FormItem
                :label="$t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.discussAuditEndDatetime.title')"
                prop="discussAuditEndDatetime"
                v-if="globalConfig.showAfterReview && liveRoomSettings.discussAuditMechanism == 1"
            >
                <DatePicker
                    ref="discussAuditEndDatetime"
                    @on-change="liveRoomSettings.discussAuditEndDatetime=$event"
                    :value="liveRoomSettings.discussAuditEndDatetime"
                    :options="discussAuditEndDatetimeOptions"
                    class="room-item"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    :placeholder="$t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.discussAuditEndDatetime.placeholder')"
                ></DatePicker>
            </FormItem>
            <FormItem :label="$t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.globalRoomCategoryId')" prop="globalRoomCategoryId">
                <CheckboxGroup v-model="liveRoomSettings.globalRoomCategoryId">
                    <Checkbox
                        v-for="i in globalCategoryList"
                        :key="i.id"
                        :label="i.id"
                    >{{ i.name }}</Checkbox>
                </CheckboxGroup>
            </FormItem>
            <!-- <FormItem :label="$t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.liveRoomCategoryId.title')" prop="liveRoomCategoryId">
                <Select v-model="liveRoomSettings.liveRoomCategoryId" class="room-item">
                    <Option :value="0" :key="0">{{ $t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.liveRoomCategoryId.none') }}</Option>
                    <Option
                        v-for="item in categoryList"
                        :value="item.id"
                        :key="item.id"
                    >{{ item.name }}</Option>
                </Select>
            </FormItem> -->
            <FormItem :label="$t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.backgroundImg.title')" style="">
                <Uploader
                    ref="uploader"
                    :action="liveRoomSettings.uploadServerUrl"
                    @save="save"
                    class="room-item"
                    :id="id"
                    :userId="userId"
                    :imageUrl="liveRoomSettings.imageUrl"
                    :fixedNumber="[16, 9]"
                    :type="5"
                    :resize="1"
                    :full="true"
                    :maxSize="uploadImageLimit"
                >
                    <Button type="primary" icon="ios-cloud-upload-outline">{{ $t('Button.uploadImg') }}</Button>
                </Uploader>
                <small>{{ $t('liveRoomManagement.liveRoomList.Edit.liveRoomSettings.backgroundImg.prompt') }}</small>
            </FormItem>
            <FormItem>
                <Button
                    v-if="hasPermission('saveLiveRoom')"
                    type="primary"
                    @click="debounce(()=>{clickSaveBtn('liveRoomForm')})"
                    :loading="save_loading"
                >{{ $t('Button.save') }}</Button>
                <Button @click="$router.go(-1)" style="margin-left: 8px">{{ $t('Button.back') }}</Button>
                <Button
                    v-if="liveRoomSettings.roomId != 0 && hasPermission('deleteLiveRoom') && !isGZTV && (liveRoomSettings.userId == userId || selectType!=2)"
                    style="margin-left: 220px"
                    type="error"
                    @click="showRemoveConfirm"
                >{{ $t('Button.remove') }}</Button>
            </FormItem>
        </Form>
        <Spin v-show="loading" fix class="spin">
            <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";
    import api from "@/api/Api";
    import extend from "extend";
    import Uploader from "@/components/upload/upload-liveroompic";
    import RemoveConfirmDialog from "@/components/RemoveConfirmDialog";
    import HtmlDecode from "@/plugins/htmlDecode";
    import cookie from 'js-cookie';
    import { beforeUnloadMixin } from "@/mixin/beforeUnloadMixin";

    const TEMPLATE_TYPE_DEFAULT = -2;
    const TEMPLATE_TYPE_CUSTOM = -1;
    const TEMPLATE_TYPE_HORIZONTAL = 0;
    const TEMPLATE_TYPE_VERTICAL = 1;

    export default {
        props: ['id'],
        mixins: [beforeUnloadMixin],
        components: {
            Uploader,
            RemoveConfirmDialog
        },
        data() {
            return {
                currentUserId:0,
                publicPageTemplateData:[],
                // publicPageTemplatefilterOption:[{value:TEMPLATE_TYPE_VERTICAL,label:"竖屏"},{value:TEMPLATE_TYPE_HORIZONTAL,label:"横屏"}],
                publicPageTemplatefilterOption:[],
                orignPublicPageTemplateData:[],
                templateOption: TEMPLATE_TYPE_DEFAULT,
                // oldtemplateId:'',
                // orginOldTemplateId: '',
                remoteOriginTemplateId: '',
                selectType:1,
                loading: true,
                save_loading: false,
                categoryList: [],
                globalCategoryList: [],
                liveRoomSettings: {
                    createRoomTime: "",
                    discussAuditEndDatetime: "",
                    discussAuditMechanism: 0,
                    discussAuditStartDatetime: "",
                    globalCategory: [],
                    globalRoomCategoryId: [],
                    imageUrl: "",
                    livePreviewUrl: "",
                    // liveRoomCategoryId: 0,
                    liveStatus: 0,
                    paidLive: 0,
                    recordSort: 0,
                    roomDescription: "",
                    roomId: 0,
                    roomTitle: "",
                    roomType: 2,
                    timeDescription: "",
                    userName: "",
                    viewNumber: 0,
                    vodFlag: 3,
                    uploadServerUrl: "",
                    templateId:0,
                    multiLive:0
                },
                //验证规则
                liveRoomRules: {
                    roomTitle: [
                        { required: true, message: this.$t('liveRoomManagement.liveRoomList.Edit.liveRoomRules.roomTitle'), trigger: 'blur' }
                    ],
                    timeDescription: [
                        // { required: true, type: 'date', message: '直播间开始时间不能为空', trigger: 'change' }
                        { required: true, message: this.$t('liveRoomManagement.liveRoomList.Edit.liveRoomRules.timeDescription'), trigger: 'change', pattern: /.+/ }
                    ],
                    roomDescription: [
                        { required: true, message: this.$t('liveRoomManagement.liveRoomList.Edit.liveRoomRules.roomDescription'), trigger: 'blur' }
                    ]
                },
                // 时间限制
                discussAuditStartDatetimeOptions: {
                    disabledDate: date => {
                        //明天以后不能选择
                        let selected = this.liveRoomSettings.discussAuditEndDatetime;
                        if (!selected || !selected.getTime) return false;

                        return date.valueOf() < selected.getTime();
                    }
                },
                // 时间限制
                discussAuditEndDatetimeOptions: {
                    disabledDate: date => {
                        let selected = this.liveRoomSettings.discussAuditStartDatetime;
                        if (!selected || !selected.getTime) return false;
                        // console.log(selected.getTime())
                        return date.valueOf() > selected.getTime();
                    }
                },
                // 删除确认
                removeDialog: {
                    visible: false,
                }
            }
        },
        computed: {
            filter: {
                get() {
                    return this.$store.state.views.liveCategory.refLiveRoom.filter;
                },
                set(v) {
                    this.$store.commit("views/liveCategory.refLiveRoom.filter", v);
                }
            },
            ...mapState({
                uploadPath: state => state.uploader.uploadPath,
                uploaderLoading: state =>
                    state.uploader.UploadServer.loadingStatus == "loading",
                uploaderReady: state =>
                    state.uploader.UploadServer.loadingStatus == "done",
                uploaderResult: state => state.uploader.newMaterialStatus,
                userId: state => state.user.id,
                globalConfig: state => state.user.globalConfig,
                isGZTV: state => state.config.profile == "gztv"
            }),
            uploadImageLimit() {
                return this.$store.getters['uploader/imageMaxSize'](this.$store.state.config.uploadImageLimit);
            }
        },
        watch: {
            uploaderResult(val) {
                let item = val[val.length - 1];
                if (!item.status) {
                    this.pagination.page == 1 && this.refresh();
                } else {;}
            }
        },
        methods: {
            selectScreenOption(obj){
                this.templateOption = obj.value;
                // if(this.templateOption == TEMPLATE_TYPE_DEFAULT){
                //     this.liveRoomSettings.templateId = 0;                    
                // } else {

                //     this.liveRoomSettings.templateId = this.oldtemplateId ;
                // }
                // 只有新建直播间才会有选模板的功能，这里就不需要考虑自定义模板的问题
                if(this.templateOption == TEMPLATE_TYPE_HORIZONTAL || this.templateOption == TEMPLATE_TYPE_VERTICAL) {
                    let first = 0;
                    let selected = 0;
                    for(let i = 0; i < this.orignPublicPageTemplateData.length; i++) {
                        if(this.orignPublicPageTemplateData[i].type == this.templateOption && first == 0) {
                            first = this.orignPublicPageTemplateData[i].id;
                        } else if(this.remoteOriginTemplateId == this.orignPublicPageTemplateData[i].id && this.remoteOriginTemplateId != -1) {
                            selected = this.orignPublicPageTemplateData[i].id;  // 服务器上保存的选中模板id
                            break;
                        }
                    }
                    if(selected) {
                        this.liveRoomSettings.templateId = selected;
                    } else {
                        this.liveRoomSettings.templateId = first;
                    }
                } else {
                    this.liveRoomSettings.templateId = 0;
                }
            },
            selectPublicPage(obj){
                this.liveRoomSettings.templateId = obj["value"];
            },
            queryPublicPageTemplate(){ 
                this.remoteOriginTemplateId = this.liveRoomSettings.templateId;
                // 从cookie取得最近一次选择的模板
                if(cookie.get("last_set_room_templateId")===undefined){
                    this.liveRoomSettings.templateId = 0;
                }else {
                    let last_set_room_templateId =cookie.get("last_set_room_templateId").replace(/\s*/g,"")
                    if(last_set_room_templateId.length<=0){
                        this.liveRoomSettings.templateId = 0;
                    }else{
                        this.liveRoomSettings.templateId = parseInt(cookie.get("last_set_room_templateId"))  
                    } 
                }
                api.call("liveRoom/getLiveHtmlList", {
                    page:1,
                    pageSize:999,
                    type:"",
                    userId:this.currentUserId
                    // userId:this.currentUserId==0?this.userId:this.currentUserId
                }, {
                    roomId: this.id
                }).then((ret)=>{                                
                    this.publicPageTemplateData = [];
                    this.orignPublicPageTemplateData = [];
                    // 没有配置直播页模板时，不显示直播页模板设置项
                    if(!ret.list || ret.list.length == 0) {
                        this.publicPageTemplatefilterOption = [];
                        return;
                    }
                    this.publicPageTemplatefilterOption =[{value:TEMPLATE_TYPE_HORIZONTAL,label:"横屏"},{value:TEMPLATE_TYPE_VERTICAL,label:"竖屏"}];
                    let t = ret.list;
                    for(var i = 0; i < t.length; i++){
                        this.orignPublicPageTemplateData.push(t[i]);
                    }
                    let foundCookieTemplate = false;
                    if(this.liveRoomSettings.templateId > 0) {
                        // cookie中有保存的模板id
                        let t = this.orignPublicPageTemplateData;
                        for(var i = 0; i < t.length; i++){
                            if(t[i].id == this.liveRoomSettings.templateId){             
                                this.templateOption = t[i].type;
                                foundCookieTemplate = true;
                                break; 
                            }
                        }
                    }
                    // cookie中没有保存的模板id，或者cookie中保存的模板ID没有在服务器返回的列表中，从服务器返回的列表选第一个横屏模板
                    if(!foundCookieTemplate) {
                        this.templateOption = TEMPLATE_TYPE_HORIZONTAL;
                        let t = this.orignPublicPageTemplateData;
                        for(var i = 0; i < t.length; i++){
                            if(t[i].type == this.templateOption){             
                                this.liveRoomSettings.templateId = t[i].id;
                                break; 
                            }
                        }
                    }
                }).catch(e=>{
                    console.log(e);
                });
            },
            async clickSaveBtn(name){
                this.loading = true;
                this.save_loading = true;
                let saveFlag;
                this.$refs[name].validate((valid) => {
                    saveFlag = valid;
                    if (saveFlag){
                        try {
                            if(!this.$refs.uploader.file.id){
                                this.save();
                            }else {
                                this.$refs.uploader.upload()
                            }
                        } catch (e) {
                            console.log(e);
                            this.$Notice.error({ title: this.$t('Message.save.error') });
                        }
                    }else {
                        this.$Notice.error({ title: this.$t('Message.save.error') });
                    }
                });
                setTimeout(()=>{
                    this.save_loading = false;
                },2000);
                this.loading = false;
            },
            async save(){
                try{
                    //接口需要字符串，进行数组转换字符串
                    this.liveRoomSettings.globalRoomCategoryId = this.liveRoomSettings.globalRoomCategoryId.toString();
                    //获取图片地址
                    this.liveRoomSettings.uploadPath = this.uploadPath;
                    // by yangyp 20210726 新增直播间，如果设置了不开启回顾，那么直播间状态默认设置为直播
                    if(this.liveRoomSettings.roomId == 0) {
                        this.liveRoomSettings.vodFlag = this.globalConfig.hideVodStatusTrailer?0:3;
                    }
                    let ret = await api.call("liveRoom/save",  this.liveRoomSettings);
                    
                    // console.log("直播间设置的模板id是")
                    // console.log(this.liveRoomSettings.templateId)
                    //设置cookie
                    if(this.liveRoomSettings.templateId!=-1){
                        cookie.set("last_set_room_templateId", this.liveRoomSettings.templateId);
                    }


                    this.$store.commit('uploader/setUploadPath', "");

                    this.$Notice.success({ title: this.$t('Message.save.success') });
                    this.$router.back();
                }
                catch (e) {
                    let msg = e.resultMsg || '';
                    if(msg.indexOf("非法字符") > -1) {
                        msg = '直播间名称或描述包含特殊字符';
                    }
                    this.$Notice.error({ title: this.$t('Message.save.error'), desc: msg });
                }
            },
            async showRemoveConfirm() {
                this.removeDialog.visible = true;
            },
            async onRemoveConfirm() {
                this.loading = true;
                this.removeDialog.visible = false;

                try {
                    let ret = await api.call("liveRoom/delete", {
                        roomId: this.liveRoomSettings.roomId
                    });

                    this.$Notice.success({ title: this.$t('Message.remove.success') + `(${this.liveRoomSettings.roomTitle})` });
                    if(this.$route.path.indexOf('refLiveRoom') < 0)
                        this.$router.push("../../all");
                    else
                        this.$router.replace("../../" + this.filter.categoryId);
                    this.refresh();
                } catch (e) {
                    this.$Notice.error({ title: this.$t('Message.remove.error') +  `(${this.liveRoomSettings.roomTitle})`, desc: e.resultMsg });
                }
                this.loading = false;
            },
            async refresh() {
                this.loading = true;
                try {
                    this.selectType = this.liveRoomSettings.userId == this.userId ? 1 : 2
                    let ret = await api.call("liveRoom/info", {
                        roomId: this.id
                    });
              
                    this.currentUserId =(ret.data === undefined)?this.userId:ret.data.userId;
                    
                    this.$store.commit("uploader/setUploadPath", "");

                    if(this.id == 0){       //新建直播间
                        this.liveRoomSettings = extend({}, true, this.liveRoomSettings, ret.uploadJson);
                    }else {         //编辑直播间
                        this.liveRoomSettings = extend({}, true, this.liveRoomSettings, ret.data, ret.uploadJson);
                        // this.liveRoomSettings.liveRoomCategoryId = 0;
                        this.liveRoomSettings.globalRoomCategoryId = [];

                        //若该直播间原来选择了分类
                        if(this.liveRoomSettings.globalCategory){
                            this.liveRoomSettings.globalRoomCategoryId = this.liveRoomSettings.globalCategory.map(i=>i.id);
                        }
                        //若该直播间原来选择了专题
                        // if(this.liveRoomSettings.category){
                        //     this.liveRoomSettings.liveRoomCategoryId = this.liveRoomSettings.category.id;
                        // }
                    }
                    this.liveRoomSettings.roomTitle = HtmlDecode.d(this.liveRoomSettings.roomTitle);
                    this.liveRoomSettings.roomDescription = HtmlDecode.d(this.liveRoomSettings.roomDescription);
                    this.$store.dispatch("uploader/getFileMaxSizes", this.liveRoomSettings.uploadServerUrl);
                } catch (e) {
                    console.log(e)
                }
                this.loading = false;
            },
            async refreshFilter(){
                try {
                    const [globalCategory, category] = await Promise.all([
                        api.call("liveRoomCategory/globalCategoryList"),
                        api.call("liveRoomCategory/list", {
                            selectType:  this.selectType,
                            userId: this.liveRoomSettings.userId ? this.liveRoomSettings.userId : this.userId
                        })
                    ]);
                    this.globalCategoryList = globalCategory.list;
                    this.categoryList = category.list;
                    //若该直播间原来选择了分类
                    if(this.liveRoomSettings.globalCategory){
                        this.liveRoomSettings.globalRoomCategoryId = this.liveRoomSettings.globalCategory.map(i=>i.id);
                    }
                    //若该直播间原来选择了专题
                    // if(this.liveRoomSettings.category){
                    //     this.liveRoomSettings.liveRoomCategoryId = this.liveRoomSettings.category.id;
                    // }
                } catch (e) {;}
            }
        },
        mounted() {
            this.refresh().then(()=>{
                this.refreshFilter();
            });
            this.queryPublicPageTemplate()
            this.$refs.discussAuditStartDatetime &&
            this.$refs.discussAuditStartDatetime.$on(
                "on-pick",
                date => {
                    this.liveRoomSettings.discussAuditStartDatetime = date;
                }
            );
            // this.$refs.discussAuditEndDatetime.$refs.pickerPanel.$on(
            //     "on-pick",
            //     date => {
            //         this.liveRoomSettings.discussAuditEndDatetime = date;
            //     }
            // );
        },
        created() {},
        beforeDestroy() {}
    }
</script>
<style lang="less" scoped>
    .edit{
        position: relative;
        border-radius: 5px;
        background: white;
        padding: 10px 20px;
    }
    .room-item{
        width: 200px;
    }
    /deep/ .input-textarea .ivu-input{
        font-size: 12px;
    }
</style>